import React from 'react';
import { Link } from '@remix-run/react';
import { routes } from '~/lib/routes';

const currentYear = new Date().getFullYear();

const GAME_LINKS = [
  { label: 'Overview', to: routes.about() },
  { label: 'Roadmap', to: `${routes.about()}#roadmap` },
  { label: 'FAQ', to: `${routes.about()}#faq` },
];

const DATABASE_LINKS = [
  { label: 'Skills', to: routes.database.skills() },
  { label: 'Enemies', to: routes.database.enemies() },
  { label: 'Status Effects', to: routes.database.statusEffects() },
];

const RESOURCES_LINKS = [
  { label: 'Devlog', to: routes.blog.index() },
];

export function Footer() {
  return (
    <footer className="border-t border-border/60 bg-muted/40 py-12">
      <div className="mx-auto grid max-w-6xl gap-10 px-6 lg:grid-cols-4 lg:px-8">
        <div className="space-y-3 lg:col-span-2">
          <div className="inline-flex items-center gap-3">
            <img
              src="/images/lumora-logo.png"
              alt="Lumora Logo"
              className="h-12 w-12 rounded-full shadow-lg"
            />
            <div>
              <p className="font-fantasy text-lg font-semibold text-foreground">Lumora</p>
              <p className="text-sm text-muted-foreground">The First Dawn</p>
            </div>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-muted-foreground">
            Lumora is an upcoming story-driven RPG about emerging magic in a world that has never
            known such power. Track the development, explore the world, and stay connected with the
            community.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:col-span-2">
          <nav className="space-y-3">
            <p className="text-sm font-semibold text-foreground">Game</p>
            <ul className="space-y-2 text-sm text-muted-foreground">
              {GAME_LINKS.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} prefetch="intent" className="transition hover:text-foreground">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav className="space-y-3">
            <p className="text-sm font-semibold text-foreground">Database</p>
            <ul className="space-y-2 text-sm text-muted-foreground">
              {DATABASE_LINKS.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} prefetch="intent" className="transition hover:text-foreground">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav className="space-y-3">
            <p className="text-sm font-semibold text-foreground">Resources</p>
            <ul className="space-y-2 text-sm text-muted-foreground">
              {RESOURCES_LINKS.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} prefetch="intent" className="transition hover:text-foreground">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>

      <div className="mt-10 border-t border-border/40">
        <div className="mx-auto flex max-w-6xl items-center justify-center px-4 py-6 text-xs text-muted-foreground sm:px-6 lg:px-8">
          <p>© {currentYear} Lumora Studio. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
